import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Marquee() {
  const [m, setM] = useState(null);
  useEffect(() => {
    api.get("/site-extras").then((r) => setM(r.data.marquee)).catch(() => {});
  }, []);
  if (!m?.enabled || !m?.text) return null;
  return (
    <div className="fixed inset-x-0 top-[68px] z-40 overflow-hidden border-b border-white/10" style={{ backgroundColor: m.bg_color }} data-testid="marquee-bar">
      <style>{`@keyframes ztk-marquee{from{transform:translateX(0)}to{transform:translateX(-50%)}}`}</style>
      <div className="flex w-max whitespace-nowrap py-2" style={{ animation: `ztk-marquee ${m.speed || 20}s linear infinite`, color: m.text_color, fontSize: `${m.font_size || 16}px` }}>
        {[0, 1, 2, 3].map((i) => (
          <span key={i} className="px-8 font-semibold" style={{ whiteSpace: "pre" }} aria-hidden={i > 0}>{m.text}</span>
        ))}
      </div>
    </div>
  );
}
